import { render, staticRenderFns } from "./Tscore.vue?vue&type=template&id=9163868e&scoped=true"
import script from "./Tscore.vue?vue&type=script&lang=js"
export * from "./Tscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163868e",
  null
  
)

export default component.exports